import { ToggleAdminUseOauth2Integration } from '@/connection/integrations/oauth';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const toggleOauthIntegrationAdminUseReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel, uuid, on }: { channel: number; uuid: string; on: boolean }, { rejectWithValue }) => {
      try {
        const isOn = await ToggleAdminUseOauth2Integration(channel, uuid, on);
        return isOn;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state) => {
        if (state.oauthIntegration) {
          state.oauthIntegration = { ...state.oauthIntegration, admin_login: !state.oauthIntegration.admin_login };
        }
      },
    }
  );
};

export default toggleOauthIntegrationAdminUseReducer;
